/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { V1StatsByDateResponse } from '../../entities/v1/StatsByDateResponse'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { v1StatDataSchema } from './statDataSchema'
import { z } from 'zod'

export const v1StatsByDateResponseSchema = z.object({
  data: z.array(z.lazy(() => v1StatDataSchema)),
  total: z.number().int(),
}) as unknown as ToZod<V1StatsByDateResponse>